_collow.components.ProfileNotifications = class ProfileNotifications extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(document.body, "change.localstorage", this.renderNotifications);
    this.listen(document.body, "_collow.connection.request", ({ detail }) =>
      this.setMessageRead(detail.id)
    );
  }

  renderNotifications = () => {
    const notifications = localStorage.getItem("notifications");
    if (!notifications) return;
    const element = this.elements.template.innerHTML;
    const notificationsHtml = JSON.parse(notifications)
      .map((msg) => {
        const date = new Date(msg.sent_datetime);
        const { sender_id, sender_username, sender_is_company } =
          msg.message_metadata;
        const link = `<a href="/company/public?id=${sender_id}" class="link" target="_blank">${sender_username}</a>`;
        const message = sender_is_company
          ? msg.message.replace(sender_username, link)
          : msg.message;

        return element
          .replace('notification-id=""', `data-notification-id="${msg.id}"`)
          .replace(
            'notification-type=""',
            `data-notification-type="${msg.type}"`
          )
          .replace('data-read=""', `data-read="${msg.read}"`)
          .replace('src=""', `src="${msg.logo_url}"`)
          .replace("message", message)
          .replace(
            "message-date",
            `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
          );
      })
      .join("\n");
    this.elements.container.innerHTML = notificationsHtml;
    this.elements.container
      .querySelectorAll("[data-request-button]")
      .forEach((btn) => this.listen(btn, "click", this.openAcceptRequest));

    this.elements.container
      .querySelectorAll("[data-btn-read]")
      .forEach((el) =>
        this.listen(el, "click", ({ target }) =>
          this.setMessageRead(
            target.closest("[data-notification-id]").dataset.notificationId
          )
        )
      );
  };

  openAcceptRequest = ({ target }) =>
    this.dispatch(this.root, "_collow.message.id", {
      id: target.closest("[data-notification-id]").dataset.notificationId,
    });

  /**
   * @param {*} id message id
   * set the message in localstorage as read and dispatch event for the notification connection
   * @returns localstorage element with id
   */
  setMessageRead = (id) => {
    let target;
    const notifications = JSON.parse(localStorage.getItem("notifications")).map(
      (ntf) => {
        if (ntf.id == id && !ntf.read) {
          ntf.read = true;
          target = ntf;
        }
        return ntf;
      }
    );
    if (!target) return;
    localStorage.setItem("notifications", JSON.stringify(notifications));
    this.dispatch(this.root, "_collow.notifications.change", {
      readMessage: target,
    });
  };
};
